import KogModalFadeComponent from '@/main/components/modal/ModalFadeComponent';
import CloseIcon from "@mui/icons-material/Close";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import { Avatar, IconButton, Tooltip } from "@mui/material";
import { useVisualIdentityReducer } from "@store/visualIdentity";
import React, { useState } from "react";
import * as S from "./styles";
import SupportContactsGrid from "./supportContactsGrid";
import { getTranslateByKey } from '@/main/services/utils';

const HeaderSupportContactsComponent: React.FC = () => {
	const [open, setOpen] = useState(false);

	const { visualIdentity: { colors } } = useVisualIdentityReducer();

	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);

	return (
    <>
      <Tooltip
        title={getTranslateByKey('information.technicalSupportContacts')}>
        <div>
          <IconButton onClick={handleOpen} id="id-supportContact-btn-open">
            <Avatar
              sx={{
                height: 35,
                width: 35,
                backgroundColor: colors.pantoneBlack,
                color: colors.white
              }}
              variant="circular"
              alt={''}>
              <SupportAgentIcon />
            </Avatar>
          </IconButton>
        </div>
      </Tooltip>

      <KogModalFadeComponent open={open} setOpen={setOpen}>
        <S.Content>
          <S.ContainerCloseButton>
            <IconButton id="id-supportContact-btn-close" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </S.ContainerCloseButton>
          <S.TitleModal>
            {getTranslateByKey('information.supportContacts')}
          </S.TitleModal>
          <div
            style={{ maxHeight: '350px', overflowY: 'auto' }}
            id="support-contacts-grid-scroll">
            <SupportContactsGrid />
          </div>
          <S.FooterText>
            {getTranslateByKey('information.portalSupportAvailability')}
          </S.FooterText>
        </S.Content>
      </KogModalFadeComponent>
    </>
  );
};

export default HeaderSupportContactsComponent;
